// extracted by mini-css-extract-plugin
export default {"skRotate":"SpanLoading_skRotate__JzKM9","skBounce":"SpanLoading_skBounce__L40CF"};